export default "__VITE_ASSET__C9Dn9B7E__"